<template>
  <CCard>
    <CCardHeader>
      <strong>Add Question</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CSelect
            label="Category"
            :options="categories"
            :value.sync="category_id"
            @change="getTopics"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect label="Topic" :options="topics" :value.sync="topic_id" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="Bangla" v-model="bangla" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="English" v-model="english" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect label="Type" :options="types" :value.sync="type" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <img
            v-if="type === 'image' && uploaded_attachment"
            :src="media_url"
            style="width: 200px; height: 200px"
          />
          <video
            v-if="type === 'video' && uploaded_attachment"
            width="320"
            height="240"
            controls
          >
            <source :src="media_url" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <audio v-if="type === 'audio' && uploaded_attachment" controls>
            <source :src="media_url" type="audio/mpeg" />
            Your browser does not support the audio tag.
          </audio>
          <div v-if="type !== 'text'">
            <CInputFile
              label="Media attachment"
              vertical
              ref="file"
              type="file"
              id="file"
              @change="onImageChange"
              style="width: 200px"
            />
            <label class="text-danger"
              >(Image/Video/Audio Size should be (360 X 360) and less than 2
              MB)</label
            >
            <progress
              max="100"
              :value.prop="upload_percentage"
              v-if="upload_percentage > 0"
            ></progress>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol col="12"><h3 class="font-weight-bold">Options</h3></CCol>
        <CCol sm="12">
          <CSelect
            label="Options Type"
            :options="['text', 'image']"
            :value.sync="answer_type"
          />
          <span class="text-danger"
            >*Insert correct answer on the 4th option</span
          >
        </CCol>
        <CCol sm="12" md="6" v-for="(option, i) in options">
          <div
            class="d-flex"
            v-if="answer_type === 'text'"
            :class="{ 'bg-success': i === 3 }"
          >
            <CInput :label="i + 1 + ' bangla'" v-model="option.bangla"></CInput>
            <CInput label="english" v-model="option.english"></CInput>
          </div>
          <div v-else-if="answer_type === 'image'">
            <!-- <input type="radio" v-model="answer_id" :value="i" /> -->
            <img
              :src="option.media_url"
              style="width: 100px; height: 100px; margin: 0.5rem"
              v-if="option.media_url !== ''"
            />
            <CInputFile
              vertical
              ref="file"
              type="file"
              @change="onOptionImageChange($event, i)"
              style="width: 200px"
            />
          </div>
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary" :disabled="loaded">
        <CIcon name="cil-checkp-circle"  />Create Question
      </CButton>
      <div v-if="loaded">
        <span>Loading</span><br />
        <CSpinner grow="true" color="danger"></CSpinner>
      </div>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "QuestionCreate",
  data() {
    return {
      bangla: "",
      english: "",
      answer_id: "",
      category_id: "",
      topic_id: "",
      type: "text",
      answer_type: "text",
      url: "",
      media_url: "",
      options: [
        { id: "", bangla: "", english: "", media_url: "", image: false },
        { id: "", bangla: "", english: "", media_url: "", image: false },
        { id: "", bangla: "", english: "", media_url: "", upload_btn: false },
        { bangla: "", english: "", media_url: "", upload_btn: false },
      ],
      categories: [],
      topics: [],
      types: ["text", "audio", "video", "image"],
      uploaded_attachment: false,
      loaded: false,
      upload_percentage: 0,
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.categories = [{ value: 0, label: "Select Category" }];
      this.$axios
        .get(`${ADMIN_URL}/categories`)
        .then((response) => {
          response.data.category_list.forEach((e) => {
            this.categories.push({
              value: e.id,
              label: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getTopics() {
      this.topics = [{ value: 0, label: "Select Topic" }];
      this.$axios
        .get(`${ADMIN_URL}/topics`, {
          params: {
            category_id: this.category_id,
          },
        })
        .then((response) => {
          response.data.topic_list.forEach((e) => {
            this.topics.push({
              value: e.id,
              label: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getQuestion() {
      this.$axios
        .get(`${ADMIN_URL}/questions/${this.$route.params.id}`)
        .then((response) => {
          console.log("categories, response === ", response.data);
          this.question = response.data.question;
          this.media_url = ROOT_URL + "/" + this.url;
          this.options = response.data.options.map((el) => {
            let o = Object.assign({}, el);
            o.media_url = ROOT_URL + "/" + el.url;
            o.upload_btn = false;
            return o;
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(e) {
      this.uploaded_attachment = true;
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.url = file;
      this.media_url = URL.createObjectURL(file);
    },
    onOptionImageChange(e, i) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.options[i].url = file;
      this.options[i].media_url = URL.createObjectURL(file);
      this.options[i].upload_btn = true;
    },
    uploadOptionImage(id, i) {
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };
      let selected_option = this.options.find((o) => {
        return o.id === id;
      });
      this.options[i].upload_btn = false;
      console.log("s", selected_option);
      let formData = new FormData();
      formData.append("id", id);
      formData.append("attachment", selected_option.url);
      this.$axios
        .post(`${ADMIN_URL}/options/update-image`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      this.loaded = true;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };
      let formData = new FormData();
      for (let i = 0; i < this.options.length; i++) {
        let file = this.options[i]["url"];
        let bangla = this.options[i]["bangla"];
        let english = this.options[i]["english"];
        formData.append("options[" + i + "][file]", file);
        formData.append("options[" + i + "][bangla]", bangla);
        formData.append("options[" + i + "][english]", english);
      }
      for (var value of formData.values()) {
        console.log(value);
      }

      formData.append("bangla", this.bangla);
      formData.append("english", this.english);
      formData.append("type", this.type);
      formData.append("answer_type", this.answer_type);
      formData.append("attachment", this.url);
      formData.append("topic_id", this.topic_id);
      formData.append("answer_id", this.answer_id);

      console.log("total", formData.values());
      console.log("attachment", this.url);

      this.$axios
        .post(`${ADMIN_URL}/questions/create`, formData, config)
        .then((response) => {
          this.loaded = false;
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
          window.location.reload();
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
        this.loaded = false
    },
  },
};
</script>

<style scoped>
</style>
